import Vue from 'vue';
import { Consoler } from './Consoler';
import { Settings } from '@/models/settings';

class ConfigDefinition extends Vue {
  public Settings: Settings = {
    ApiBaseUrl: '',
    FullConsole: 'false'
  };

  public SetSettings(settings: Settings) {
    Consoler.debugLog('Setting settings:', settings);
    this.Settings = settings;
  }
}

export const Config = new ConfigDefinition();
